import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

const quickLinks = [
  { label: "电影", to: "/category/movie", icon: "ri-film-line" },
  { label: "电视剧", to: "/category/tv", icon: "ri-tv-2-line" },
  { label: "综艺", to: "/category/variety", icon: "ri-mic-line" },
  { label: "专题合集", to: "/special", icon: "ri-stack-line" },
];

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - WW我的快乐在哪里",
    description: "抱歉，你访问的页面不存在或已失效，可返回首页继续浏览影视资讯与剧情介绍。",
    keywords: "页面不存在,WW我的快乐在哪里",
  });

  return (
    <section className="mx-auto flex w-full max-w-page flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-accent-100 text-accent-700">
        <i className="ri-emotion-laugh-line text-4xl" aria-hidden="true" />
      </span>
      <p className="mt-6 text-5xl font-black text-primary-600 md:text-6xl">404</p>
      <h1 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">这个页面好像走丢了</h1>
      <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
        我们没有找到 <span className="font-mono text-foreground-800">{location.pathname}</span> 对应的内容。
        它可能已被移除，或者链接输入有误。不如回到首页，继续找你的快乐。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700 whitespace-nowrap"
        >
          <i className="ri-home-4-line" aria-hidden="true" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap"
        >
          <i className="ri-search-line" aria-hidden="true" />
          去搜索内容
        </Link>
      </div>

      <div className="mt-12 w-full max-w-2xl">
        <h2 className="text-sm font-semibold text-foreground-500">或者直接前往</h2>
        <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {quickLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="group flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-3 py-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600" aria-hidden="true">
                <i className={`${link.icon} text-xl`} />
              </span>
              <span className="text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                {link.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}